import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {IonicModule} from '@ionic/angular';
import {CardModule} from '../../../../../../core/component/card/card.module';
import {SaleInvoiceDetailsCardComponent} from './sale-invoice-details-card.component';
import {FormFieldModule} from '../../../../../../core/component/form-field/form-field.module';
import {DateLabelModule} from '../../../../../../core/component/date/date-label/date-label.module';
import {SaleSummaryFieldModule} from '../../../../../api/component/sale-summary-field/sale-summary-field.module';
import {
    DocumentSummaryModelFieldModule
} from '../../../../../../document/common/api/component/document-summary-field/document-summary-field.module';

@NgModule({
    imports: [
        CommonModule,
        IonicModule,
        CardModule,
        FormFieldModule,
        DateLabelModule,
        SaleSummaryFieldModule,
        DocumentSummaryModelFieldModule,
    ],
    declarations: [
        SaleInvoiceDetailsCardComponent,
    ],
    exports: [
        SaleInvoiceDetailsCardComponent
    ],
})
export class SaleInvoiceDetailsCardModule {
}
